import { Checkpoint } from '../../../../../models2/localization/checkpoint';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  HttpService,
  MenuBreadCrumb,
  MessageService,
} from 'brainloper-ui';
import {
  ITravelRoute,
  TravelRoute,
} from '../../../../../models2/localization/travel-route';
import { MatDialog } from '@angular/material/dialog';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { MapComponent } from 'app/components/shared/map/map.component';
import { MapRoute, Marker } from 'app/models2/localization/map-route';
import { th } from 'date-fns/locale';

@Component({
  selector: 'app-router-detail',
  templateUrl: './router-detail.component.html',
  styleUrls: ['./router-detail.component.scss'],
})
export class RouterDetailComponent implements OnInit {
  @ViewChild('mapComponent', { static: false }) mapComponent!: MapComponent;
  @Output() completeRouter = new EventEmitter<any>();
  @Input() locationRouteId: number ;

  private urlHandlerRouter: string = `${EndpointDictionary.TravelRoute.CRUD_TRAVEL_ROUTER}`;

  public controlPointer: Array<Checkpoint> = [];
  public routeForm: UntypedFormGroup;
  private travelRoute: TravelRoute = new TravelRoute();
  public markers: Marker[] = [];
  public movil: boolean = false;

  menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Rutas',
      router: 'localization/router',
    },
    {
      name: 'Detalle',
      current: true,
    },
  ];

  constructor(
    private message: MessageService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.routeForm = this.formBuilder.group({
      name: '',
      distance: 0,
      timeHours: 0,
      description: '',
      activateReverse: 0,
    });
  }

  public hasMarkers: boolean = false;

  async ngOnInit() {
    this.message.openLoading('Cargando', 'Cargando Mapa');
    this.movil = screen.width > 600 ? false : true;
    let routerId: number = this.locationRouteId;
    if (!routerId) {
      setTimeout(() => {
        this.message.Info('', 'Escoja el punto de origen', false, 'Continuar');
      }, 500);
    }

    await this.initializeTravelRouter(routerId);
    this.message.closeLoading();
    this.cdr.detectChanges();
  }

  async initializeTravelRouter(routerId: number) {
    if (!routerId) {
      return;
    }

    let res: TravelRoute[] = await this.http.getDataBody<TravelRoute[]>(
      `${this.urlHandlerRouter}/${routerId}`
    );
    if (res[0]) {
      this.travelRoute = res[0];
    } else {
      this.completeRouter.emit();
      return;
    }

    for (let controls of Object.keys(this.routeForm.controls)) {
      if (this.travelRoute[controls]) {
        this.routeForm.controls[controls].setValue(
          this.travelRoute[controls].toString()
        );
      }
    }

    this.controlPointer = this.travelRoute.checkpoints;
    this.convertCheckpointsToMarkers();
  }

  convertCheckpointsToMarkers() {
    this.markers = this.controlPointer.map((checkpoint, index) => {
      let markerOrder: string;

      if (index === 0) {
        markerOrder = 'Punto Origen';
      } else if (index === this.controlPointer.length - 1) {
        markerOrder = 'Punto Destino';
      } else {
        markerOrder = `Punto de Control ${index}`;
      }

      return {
        position: { lat: checkpoint.latitude, lng: checkpoint.longitude },
        option: { draggable: true },
        order: markerOrder,
        id: checkpoint.name,
      };
    });
  }

  validateControlPointer(){
    if (this.controlPointer.length <= 2) {
      this.message
        .Warning(
          'Advertencia',
          'Esta ruta no tiene puntos de control creados',
          true,
          'Crear puntos de control',
          'Guardar rutas sin puntos de control'
        )
        .then((res) => {
          if (res) {
            this.mapComponent.routerFinished = false;
            return
          }else{
            this._saveRouter(this.travelRoute)
          }
        });
    }else{
      this._saveRouter(this.travelRoute)
    }
  }

  async saveRouter(form: TravelRoute) {
    this.travelRoute.name = form.name
    this.travelRoute.description = form.description
    this.travelRoute.distance = form.distance
    this.travelRoute.timeHours = form.timeHours
    this.travelRoute.activateReverse = form.activateReverse
    this.mapComponent.calculateRoute(true, this.travelRoute.activateReverse === 1 ? true : false);

  }

  private async _saveRouter(form: TravelRoute) {
    var isEdit: boolean =
    this.travelRoute && this.travelRoute.id ? true : false;
    this.message.openLoading(
      'Cargando',
      isEdit ? 'Actualizando ruta' : 'Creando ruta'
    );
    form.checkpoints = this.controlPointer;

    let res = null;
    let message = 'Ruta creada';

    if (isEdit) {
      form.id = this.travelRoute.id;
      res = await this.http.putDataBody<GenericResponse>(
        this.urlHandlerRouter,
        form
      );
      message = 'Ruta actualizada';
    } else {
      res = await this.http.postDataBody<GenericResponse>(
        this.urlHandlerRouter,
        form
      );
    }

    if (res) {
      this.message.SuccessToast(message);
      this.completeRouter.emit();
    }

    this.message.closeLoading();
  }

  deleteRouter($event) {
    $event.preventDefault();
  }

  back($event) {
    $event.preventDefault();
    this.completeRouter.emit(false);
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario');
  }

  getRouter($event: MapRoute) {
    const distanceInt: number = Math.round(parseFloat($event.travelDistance));
    const timeHoursInt: number = Math.round(parseFloat($event.travelTime));

    this.routeForm.patchValue({
      distance: distanceInt,
      timeHours: timeHoursInt,
    });

    this.travelRoute.distance = distanceInt;
    this.travelRoute.timeHours = timeHoursInt;

    this.controlPointer = $event.markers.map((marker, index) => {
      const checkpoint = new Checkpoint();
      checkpoint.id = index;
      checkpoint.name = marker.id;
      checkpoint.position = index;
      checkpoint.latitude = marker.position.lat;
      checkpoint.longitude = marker.position.lng;
      return checkpoint;
    });

    if($event.saveRoute) this.validateControlPointer()
  }
}
